export default __webpack_public_path__ + "static/media/Konnie 9781408356296.55246229.jpg";